import React from "react";

const Bonds = () => {
  return <div>Bonds</div>;
};

export default Bonds;
